import NewsHero from '../components/news/Hero';
import Posts from '../components/news/Posts'
import Contact from '../components/home/Contact';

function News() {
  return (
    <>
      <NewsHero />
      <Posts />
     
      <Contact />
    </>
  );
}

export default News;
